import EffectCard from '@/components/EffectCard';
import useGridColumns from '@/hooks/useGridColumns';
import useFeedReturnScroll from '@/hooks/useFeedReturnScroll';

import useStyles from './styles';
import type { SeeAllCategoryProps } from './types';

const SeeAllCategory = ({
  slug,
  items,
  onPresetClick,
  dataTestId = 'see-all-category',
}: SeeAllCategoryProps) => {
  const classes = useStyles();
  const { columnCount } = useGridColumns();
  const containerRef = useFeedReturnScroll<HTMLDivElement>();

  return (
    <div
      ref={containerRef}
      className={classes.container}
      data-testid={dataTestId}
    >
      <div
        className={classes.grid}
        style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}
        data-testid={`${dataTestId}-grid`}
      >
        {items.map((item) => (
          <div key={item.id} className={classes.cell} data-slug={item.slug}>
            <EffectCard
              item={item}
              onClick={() => onPresetClick(item.slug, slug)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SeeAllCategory;
